import { Controller } from "stimulus";
import debounce from 'lodash.debounce';
import Cookies from 'js-cookie';
import {getState, setState} from '../search_results/state'
import Filter from '../filter'

export default class extends Controller {

  // IDX Registration information.  Probably do not need idx_registration.js any longer.
  idxRegistrationRequested = false
  idxRegModalHeader = '<div class="t-title--large">Register</div>'
  idxRegModalBodyContent = `Would you like to register for a free account to track your favorite listings and categorize them into carts?`
  idxRegModalButtons = `<div>
    <button class="btn btn-tertiary" data-dismiss="modal" type="button">Cancel</button>
    <button class="btn btn-primary" type="button" data-action="click->search-results#idxRegistrationRequest">Register</button>
  </div>`


  connect() {
    // NOT SURE IF THIS IS THE RIGHT WAY TO HANDLE THE RESIZE
    window.addEventListener('resize', debounce(this.windowResize,500))

    if (this.element.dataset.searchResultsSavedsearchId) {
      // For performance reasons it is best to only add the listener if you need to.
      window.addEventListener("beforeunload", this.checkForSearchChanges.bind(this))
    }

    window.addEventListener("pagehide", this.clearTheSessionLdp.bind(this))

    // Make this check before calling other things so we can redirect faster if that
    // is what we are going to do.
    let currentURL = new URL(window.location.href);
    let windowState = window.history.state;

    var filterable = this.data.get('is-filterable');
    var isReactNativeFilterScreenEnabled = window?.nativeAppInterface?.isReactNativeFilterScreenEnabled() ?? false;
    
    if(filterable === 'true'){
       if(isReactNativeFilterScreenEnabled){
        const filter = getState('filter');

        /**
         * Open the Android App's Filter Panel
         * */
        const filterString = filter.toString();
        /**
         * We explicitly want these to be undefined and not null if there is no value
         */
        const templateId = this.data.get('savedsearch-template-id') ?? undefined;
        const quickSearchId = this.data.get('quicksearch-id') ?? templateId;
        const savedSearchId = this.data.get('savedsearch-id') ?? undefined;
        const comparableSearchId = this.data.get('comparablesearch-id') ?? undefined;

        const shapes = filter.shapes();

        window.searchResultsData = {
          filterString,
          quickSearchId,
          savedSearchId,
          comparableSearchId,
          shapes
        };

        // Display the filter button
        document.querySelector('.sub-nav__toggle--left')?.classList?.remove('active');

        window.nativeAppInterface.displayFilterScreen({ filterString, quickSearchId, savedSearchId, comparableSearchId, shapes, isInitialLoad: true });
      } else {
         /*
          Show the mweb filter panel
        */
        document.querySelector('.c-menubar--left')?.classList?.add('open');
      }
    }

    if (Flexmls.currentUser.role === 'idx') {
      // Add a listener to see if a turbo frame has been loaded.
      // If we are an IDX user we should check to see if we should
      // be asked about logging in.  IDX rules apply.  Some agents
      // allow the user to bypass registration.
      // This is the bypass check.
      document.addEventListener('turbo:frame-load', debounce(this.checkForIdxRegistration.bind(this),500))
    }
  }

  disconnect() {
    window.removeEventListener('resize', this.debounceResize)
    if (this.element.dataset.searchResultsSavedsearchId) {
      window.removeEventListener("beforeunload", this.checkForSearchChanges.bind(this))
    }
    window.removeEventListener("pagehide", this.clearTheSessionLdp.bind(this))
    sessionStorage.removeItem("highlightedListingId");

    //window.removeEventListener('popstate', this.handlePopState)
  }

  clearTheSessionLdp(evt) {
    // If we are leaving the page we want to erase this.  The LDP will reload
    // properly if we 'go back' because it is defined in the URL.
    sessionStorage.removeItem("listingsSpaHistory")
  }

  checkForSearchChanges(evt) {
    if ($('[data-controller="idx-registration"]').length > 0) {
      // Someone has asked the user to login.  We want to leave the page
      // without checking for changes.
      return;
    }
    if (this.idxRegistrationRequested === true || typeof Cookies.get('saveSearchAfterLogin') !== 'undefined') {
      // The user was prompted to register/login and they agreed.  Don't
      // prompt them to save changes.  They can't without loggin in.

      // OR

      // The user insnt logged in AND they are trying to save a search AND we are redirecting to the login page now.
      // Dont prompt to leave.  They will be sent back to the page and the save search modal will open.
      return;
    }
    // We only get here if a saved search has changed.  BUT, if a saved search has
    // changed and we saved those changes to a new search, we dont care about checking
    // the filter.  We want to load the new search as it was saved while keeping the
    // current search untouched.
    if ($('body').attr('data-save-search-complete') !== 'true') {
      if (!getState('filter').equalToOriginal()) {
        evt.preventDefault()
        evt.returnValue = "Changes detected."
      }
    }
  }

  updateCount(data) {
    if (data.detail !== null && typeof data.detail.message !== 'undefined') {
      $('.totalCount').html(data.detail.count);
    }
  }

  filterChanged(data) {
    // This is a good time to check to see if an idx user that
    // can bypass registration should be prompted to do so.
    // This would apply for timed rules and search interation rules.
    if (Flexmls.currentUser.role === 'idx') {
      setTimeout(this.checkForIdxRegistration.bind(this), 1000);
    }
  }

  windowResize() {
    console.log("WINDOW RESIZED!")
  }

  filterFormReloaded(data) {
    let count = data.detail.count
    let newExpressions = data.detail.expressions

    setState('listingCountTotal', count)

    let newFilter = new Filter(newExpressions, mapSupport.locationFields)

    let oldExpressions = getState('filter').expressions()

    var added = new Filter(Filter.expressionsAdded(oldExpressions, newExpressions), mapSupport.locationFields)
    var removed = new Filter(Filter.expressionsRemoved(oldExpressions, newExpressions), mapSupport.locationFields)

    // If there is one shape still here, they are all still here.  Only delete annotations if there are no shapes.
    var deleteAnnotations = true;
    newExpressions.forEach( function(expression) {
      if (expression.type === 'shape' || expression.field === 'MapOverlayShape') {
        deleteAnnotations = false;
      }
    })
    if (deleteAnnotations) {
      setState('annotations',[])
      sessionStorage.removeItem('annotations')
    }

    let existingFilter = getState('filter')
    if (existingFilter.toString() !== newFilter.toString()) {
      // Dont set the filter again if we got here because of a filter change.

      // TODO: In search_results.js, there is a lot more that goes on before setting the filter state.
      // Still need to figure out how much of that we need to do.
      setState('filter',newFilter, {
        /**
         * If a change to the filter was made from the Android App's Fitler Screen, 
         * we don't want setState to pass that data right back to Android and cause a loop
         */
        isFromNativeAppFilterScreen: window.nativeAppInterface && window.nativeAppInterface.isNative()
      })
    }
  }

  /*
  handlePopState(event) {
    const state = history.state;
    if (state) {
      if (state.turbo) {
        console.log("Got a pop state event and it seems as if we need to ignore this turbo state")
        console.log("My session state: ", JSON.parse(sessionStorage.getItem('listingsSpaHistory')));
        return;
      }
      if (state.itemUrl.length > 0) {
        // We have a frame to load.  But don't push do pushState because this load
        // is a result of the previous state going back to here.
        console.log("We have a frame to load.  But don't push do pushState because this load is a result of the previous state going back to here", state)
        //loadLDPTurboFrame(state.itemUrl, false)
      } else {
        // No item to show.  Hide the turbo-frame
        console.log("No item to show.  So we need to do anything else?", state)
        //$('#content-turbo-frame').addClass('hidden');
      }
    } else {
      // We are at the main results page and we just need to make sure there are no
      // listings displayed.
      console.log("We are back at our main page.  Make sure the overlay is hidden????")
      //$('.displayed-in-ldp').removeClass('displayed-in-ldp');
      //$('#content-turbo-frame').addClass('hidden');
    }
  }
  */

  listingCountTotalChanged(data) {
    // Update any header informatin that has the count
    $('.search-results-count .totalCount').text(data.detail.newValue);
  }

  checkForIdxRegistration(event) {
    let showIdxRegistrationPrompt = (Cookies.get('showIdxRegistration') === 'true');

    if (showIdxRegistrationPrompt) {
      Cookies.set('showIdxRegistration', false, { expires: 1, path: '/' });

      window.dispatchEvent(
        new CustomEvent("display-local-modal", {
          detail: {
            modalCssClasses: "modal-dialog modal-sm c-modal",
            modalHeader: this.idxRegModalHeader,
            modalContent: this.idxRegModalBodyContent,
            modalFooterContent: this.idxRegModalButtons
          }
        })
      )
    }
  }

  // This is the action if the user clicks the 'Register' button
  idxRegistrationRequest(evt) {
    evt.preventDefault()

    // Tell the 'beforeunload' event not to prevent the user
    // from leaving the page.
    this.idxRegistrationRequested = true

    // Leave the page.
    let newLocation = new URL(Flexmls.currentUser.authUri)
    newLocation.searchParams.set('state',window.location.href)
    window.location = newLocation;
  }

}
